<template>
  <main-layout>
    <div class="container fluid"></div>
  </main-layout>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/cityfresh/main.vue